import {
	Accordion,
	Alert,
	Avatar,
	Badge,
	BHAvailabilityInStore,
	BHBreadcrumbs,
	BHChangeCountryLanguageTrigger,
	BHCrossSell,
	BHDatePicker,
	BHFooterBar,
	BHHeader,
	BHInput,
	BHMosaicGallery,
	BHNewsletter,
	BHQuickBuy,
	BHRecentlyViewed,
	BHRelated,
	BHRelatedAttributes,
	BHSearch,
	BHSlider,
	BHSliderThumbs,
	BHSuggestedStoreRow,
	BHTileBase,
	BHUpsells,
	BHVerticalThumbs,
	BHViewMode,
	Button,
	Card,
	Checkbox,
	Chip,
	CircularProgress,
	Container,
	CssBaseline,
	DatePicker,
	Dialog,
	Drawer,
	Dropdown,
	Form,
	Grid,
	IconButton,
	Input,
	LinearProgress,
	Link,
	List,
	Pagination,
	Radio,
	Rating,
	Slider,
	Stepper,
	SvgIcon,
	Switch,
	Table,
	TablePagination,
	Tabs,
	TextField,
	ToggleButton,
	Tooltip,
	Typography,
} from './components'
import globalTheme from './global'

globalTheme.components = {
	...Accordion,
	...Alert,
	...Avatar,
	...Badge,
	...BHAvailabilityInStore,
	...BHBreadcrumbs,
	...BHChangeCountryLanguageTrigger,
	...BHCrossSell,
	...BHDatePicker,
	...BHFooterBar,
	...BHHeader,
	...BHInput,
	...BHMosaicGallery,
	...BHNewsletter,
	...BHQuickBuy,
	...BHRecentlyViewed,
	...BHRelated,
	...BHRelatedAttributes,
	...BHSearch,
	...BHSlider,
	...BHSliderThumbs,
	...BHSuggestedStoreRow,
	...BHTileBase,
	...BHUpsells,
	...BHVerticalThumbs,
	...BHViewMode,
	...Button,
	...Card,
	...Checkbox,
	...Chip,
	...CircularProgress,
	...Container,
	...CssBaseline,
	...DatePicker,
	...Dialog,
	...Drawer,
	...Dropdown,
	...Form,
	...Grid,
	...IconButton,
	...Input,
	...LinearProgress,
	...Link,
	...List,
	...Pagination,
	...Radio,
	...Rating,
	...Slider,
	...Stepper,
	...SvgIcon,
	...Switch,
	...Table,
	...TablePagination,
	...Tabs,
	...TextField,
	...ToggleButton,
	...Tooltip,
	...Typography,
}

export default globalTheme
